import http from "@/shared/axios-config/g-http-metodos";

function AllProdutosEmEstoque(objFiltros) {
    const{res, erro, requisicao} = http.postArray(`/ProdutoEstoque/AllProdutosEmEstoque`, objFiltros)
    return{ ProdEstoqueArray : res , erro, requisicao}
}

function GetClienteAgrupador(objFiltros) {
    const{res, erro, requisicao} = http.postArray(`/ProdutoEstoque/GetClienteAgrupador`, objFiltros)
    return{ ProdEstoqueArray : res , erro, requisicao}
}

function GetSegmentoProdutoEstoqueEnum() {
    const { res, erro, requisicao } = http.getArray("ProdutoEstoque/GetSegmentoProdutoEstoqueEnum");
    return { SegmentoProdutoEstoqueArray: res, erro, requisicao }
}

function GetTipoProdutoEstoqueEnum() {
    const { res, erro, requisicao } = http.getArray("ProdutoEstoque/GetTipoProdutoEstoqueEnum");
    return { TipoProdutoEstoqueArray: res, erro, requisicao }
}

const ProdutoEstoqueController = { 
    GetClienteAgrupador,
    AllProdutosEmEstoque,
    GetTipoProdutoEstoqueEnum,
    GetSegmentoProdutoEstoqueEnum
}

export default ProdutoEstoqueController